// Formatage monétaire partagé par les pages Finances (Pilotage, Trésorerie, TVA).
// À importer dans `methods` pour rester utilisable dans les templates Options API.

export function euro(v) {
  return (Number(v) || 0).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
}

export function signed(v) {
  const n = Number(v) || 0;
  return (n >= 0 ? "+" : "−") + Math.abs(n).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
}

export function compact(v) {
  return (Number(v) || 0).toLocaleString("fr-FR", { notation: "compact", maximumFractionDigits: 1 }) + " €";
}

export function pct(v) {
  if (v == null) return "—";
  const n = Number(v) || 0;
  return (n >= 0 ? "+" : "") + n.toLocaleString("fr-FR") + " %";
}
